module.exports = __webpack_public_path__ + "img/p98.5cc6120f.png";